// 1. Imports
import { Container, Stack, Divider } from "@mui/material";
import { Page } from "../../../components";
import HeaderBreadcrumbs from "../../../components/header-breadcrumbs";
import { StartCampaignComponent } from "../../../components/message-center/v2/start-campaign-component";
import { ScheduledMessagesComponent } from "../../../components/message-center/v2/scheduled-messages-component";
import { GT_COLORS } from "../../../constants/designTokens.constants";

// 2. Component Def
export const MessageCenterScreen = () => {
    // 2.1 State and Vars

    // 2.2 Effects

    // 2.3 Functions

    // 2.4 JSX Return
    return (
        <Page title="POM Safe - Message Center">
            <Container maxWidth={false}>
                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <HeaderBreadcrumbs 
                        heading="Message Center"
                        links={[]}
                        activeLast={false}
                    />
                </Stack>
                
                {/* Individual components */}
                <Stack direction={"column"} spacing={3}>
                    {/* Scheduled Messages Section */}
                    <ScheduledMessagesComponent />
                    
                    {/* Divider */}
                    <Divider sx={{ my: 2, borderColor: GT_COLORS.borderLight }} />
                    
                    {/* Start Campaign Section */}
                    <StartCampaignComponent />
                </Stack>
            </Container>
        </Page>
    );
}